import { Subcategory } from '../models';

/**
 * Returns the possible category path based on the current page path and subcategories.
 * It is useful when SEO filter is applied and path filter value matches last category path part
 * E.g. /prekes/ismanieji-laikrodziai-ir-apyrankes/ismanieji-laikrodziai and
 * /prekes/ismanieji-laikrodziai-ir-apyrankes/ismanieji-laikrodziai/ismanieji-laikrodziai
 */
export const getCategoryPathFromSubcategories = (path: string, subcategories?: Subcategory[]) => {
    if (!subcategories) {
        return undefined;
    }

    return subcategories.find((subcategory) => path.startsWith(subcategory.url))?.url;
};
